/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expand_Aria_LabelInputs */

const en_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand event text`)
};

const fr_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elargir le texte de l'evenement`)
};

const de_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignistext erweitern`)
};

const it_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espandi il testo dell'evento`)
};

const ru_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развернуть текст события`)
};

const es_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir el texto del evento`)
};

const zh_cn2_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展开事件文本`)
};

const ja_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストを展開`)
};

const hi_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट का विस्तार करें`)
};

const pt_pt2_expand_aria_label = /** @type {(inputs: Expand_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expandir texto do evento`)
};

/**
* | output |
* | --- |
* | "Expand event text" |
*
* @param {Expand_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const expand_aria_label = /** @type {((inputs?: Expand_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expand_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_expand_aria_label(inputs)
	if (locale === "de") return de_expand_aria_label(inputs)
	if (locale === "it") return it_expand_aria_label(inputs)
	if (locale === "ru") return ru_expand_aria_label(inputs)
	if (locale === "es") return es_expand_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_expand_aria_label(inputs)
	if (locale === "ja") return ja_expand_aria_label(inputs)
	if (locale === "hi") return hi_expand_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_expand_aria_label(inputs)
	return en_expand_aria_label(inputs)
});